<header class="global-header">
  <div
    class="header-content"
    [class.header-max-size]="hideSideNavigationIa$ | async"
  >
    <i2g-router-link
      *ngIf="hideSideNavigationIa$ | async"
      class="i2g-logo"
      [icon]="i2gIcon"
      [route]="homeRoute"
    ></i2g-router-link>

    <i2g-input-field
      *ngIf="!(hideSideNavigationIa$ | async)"
      class="search"
      [hideLabel]="true"
      [placeholder]="'LABEL.SEARCH' | translate"
      [fieldControl]="searchControl"
      [leftIcon]="searchIcon"
      [trackingObject]="trackingObject"
      [trackingAction]="searchTapped$ | async"
    >
    </i2g-input-field>
    <div class="h-spacer"></div>
    <div class="notification" (click)="toggleNotificationsTray()">
      <i2g-icon
        data-tooltip-id="ia-notification-icon"
        class="notification-bell-icon"
        name="notification-bell"
        size="medium"
      ></i2g-icon>
      <div
        *ngIf="newNotificationsCount$ | async as newNotificationsCount"
        class="notification-counter"
      >
        {{ newNotificationsCount }}
      </div>
    </div>
    <div class="profile-wrapper">
      <div #profileButton class="profile-button">
        <i2g-icon class="profile-icon" name="profile" size="medium"></i2g-icon>
        <div class="profile-name-email">
          {{ (companyName$ | async) || (user$ | async).email }}
        </div>
        <i2g-icon
          data-tooltip-id="ia-profile-icon"
          class="chevron-icon"
          name="chevron-down"
          size="small"
          [class.is-profile-dialog-open]="isProfileDialogOpen"
        ></i2g-icon>
      </div>

      <div #profileDialog *ngIf="isProfileDialogOpen" class="profile-dialog">
        <div *ngIf="companyName$ | async" class="company-name">
          {{ companyName$ | async }}
        </div>
        <div class="email-edit">
          <div class="email" [class.bold]="!(companyName$ | async)">
            {{ (user$ | async).email }}
          </div>
          <div class="button-link" (click)="changeEmail()">
            {{ 'ACTION.EDIT' | translate }}
          </div>
        </div>
        <div class="account-id">
          {{ 'LABEL.ACCOUNT_ID' | translate }}:
          {{ (account$ | async).accountId }}
        </div>
        <div class="button-link" (click)="onAccountAndSettingsClicked()">
          {{ 'LABEL.ACCOUNT_AND_SETTINGS' | translate }}
        </div>
        <div class="divider"></div>
        <button
          i2gButton
          buttonStyle="default"
          class="logout"
          (click)="logout()"
        >
          {{ 'ACTION.LOG_OUT' | translate }}
        </button>
      </div>
    </div>
  </div>
</header>

<div
  class="notifications-overlay"
  [class.open]="isNotificationsTrayOpen"
  (click)="toggleNotificationsTray()"
></div>
<div class="notifications-tray" [class.open]="isNotificationsTrayOpen">
  <div class="notification-title">
    <div>{{ 'HOME.NOTIFICATIONS.HEADER' | translate }}</div>
    <div
      *ngIf="newNotificationsCount$ | async as newNotificationsCount"
      class="notification-counter"
    >
      {{ newNotificationsCount }}
    </div>
    <i2g-icon
      class="notifications-close"
      name="close-navigation"
      size="medium"
      (click)="toggleNotificationsTray()"
    ></i2g-icon>
  </div>
  <app-notifications-list
    class="notifications-list"
    [notifications$]="notifications$"
    [trackingScreenName]="trackingScreenName$ | async"
    (onClickNotification)="onClickNotification($event)"
    (onDismissNotification)="onDismissNotification($event)"
  ></app-notifications-list>
</div>
